import React from 'react';
import LegalPage from './LegalPage';

const SECTIONS = [
  {
    heading: 'Who we are',
    paragraphs: [
      'Upgraded Technologies Inc. (“Upgraded”) collects, uses, and discloses personal information through getupgraded.ai, getupgraded.ca, app.getupgraded.ca, and our grant platform. Contact: hello@getupgraded.ai, 2631 W 2nd Ave., Vancouver, BC, V6K 1K1.',
    ],
  },
  {
    heading: 'Information we collect',
    paragraphs: [
      'Account data (name, email, phone, password), company profile data used to match programs, marketing emails you opt into, location inferred from IP or a profile address, survey responses, payment details via our processor, job-application materials, and support messages.',
      'We also collect technical usage data such as device, browser, IP address, and pages visited, including via cookies and analytics.',
    ],
  },
  {
    heading: 'How we share information',
    paragraphs: [
      'We share information with service providers (hosting, marketing, support, payments) who may process data in Canada, the US, or other jurisdictions. We may disclose information for legal process, fraud prevention, or a corporate transaction. At your request we may share information with affiliated professionals (writers, accountants, consultants).',
    ],
  },
  {
    heading: 'Your choices',
    paragraphs: [
      'You may unsubscribe from marketing emails, limit cookies in your browser, and request access or correction of personal information by emailing hello@getupgraded.ai. We do not knowingly collect information from children under 13.',
    ],
  },
];

export default function PrivacyPolicyPage() {
  return <LegalPage title="Privacy policy" updated="October 4, 2023" sections={SECTIONS} />;
}
